<template>
  <span v-if="isAllowed">
    <slot />
  </span>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const authModule = createNamespacedHelpers('authentication')
const configModule = createNamespacedHelpers('config')
import { isAllowed } from '@/utils/authentication'
export default {
  name: 'IsAllowed',
  props: {
    role: {
      type: String,
      required: true
    },
    division: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    ...authModule.mapGetters(['user']),
    ...configModule.mapState(['currentDivision']),
    isAllowed() {
      const division =
        this.division !== '' ? this.division : this.currentDivision
      if (isAllowed(this.user, this.role, [division])) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style></style>
